import { render, staticRenderFns } from "./AuthorCourse.vue?vue&type=template&id=08a6f58e&scoped=true"
import script from "./AuthorCourse.vue?vue&type=script&lang=js"
export * from "./AuthorCourse.vue?vue&type=script&lang=js"
import style0 from "./AuthorCourse.vue?vue&type=style&index=0&id=08a6f58e&prod&lang=css"
import style1 from "./AuthorCourse.vue?vue&type=style&index=1&id=08a6f58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6f58e",
  null
  
)

export default component.exports